import { executeCallbackAsync } from "./callback.js";

type HybridLegacy = {
  /*                                                    */
  onHybridDetected(callback: () => void): void;
  /*                                                    */
  executeOrRegisterCallback: (callback: () => void) => void;
};

export const hybridLegacy = (): HybridLegacy => {
  const res: HybridLegacy = {
    onHybridDetected(callback: () => void): void {
      otto.device.pointerType.sub(
        ({ isHybrid }) => {
          if (isHybrid) {
            executeCallbackAsync(callback);
          }
        },
        { once: true },
      );
    },
  } as HybridLegacy;

  res.executeOrRegisterCallback = res.onHybridDetected;
  return res;
};
